<template>
    <div class="row mb-4">
        <div class="col-24">
            <div v-if="isLoading" class="d-flex justify-content-center">
                <loader></loader>
            </div>

            <div v-if="!isLoading">
          
                    <div class="row ">
                        <div class="col-xl-24 mb-4 "
                             v-for="p in availablePackages"
                             v-bind:key="p.Code">
                          
                            <account-package-panel v-bind:availability="p"
                                                   v-bind:isHorizontal="false"
                                                   v-bind:booking="booking">   </account-package-panel>

                        </div>










                </div>
            </div>
        </div>
    </div>


</template>

<script>
    import { _ } from 'vue-underscore';

    import stayapi from '@/shared/api/stay';

    import { accountStore } from '../store/index';
    import Loader from '@/shared/components/Loader.vue';

    import AccountPackagePanel from '../components/AccountPackagePanel.vue';

    export default {
        name: 'AccountStayUpsell',
        components: {
            Loader,
            AccountPackagePanel
        },
        props: {
            booking: Object,
        },
        data() {
            return {
                isLoading: true,
                localPackages: []

            }
        },
        computed: {
            packages() {

                let result = [];


                let availability = this.localPackages;

                if (!availability.length) {
                    return;
                }

                let accountConfiguration = accountStore.getters.accountConfiguration;

                let configuration = accountConfiguration.AddOns;


                let rateCodes = this.booking.map(item => item.RateCode);



                //var rateGroupsRates = booking.legs.map(item => item.rate.rateGroupRate.AllowedAddOnPackages);
                //var allowedRateCodes = _.union(...rateGroupsRates);

                let allowedRateCodes = [];
                for (var rc in rateCodes) {
                    let rateCode = rateCodes[rc];
                    let rate = accountConfiguration.RateTypes.find(item => item.PMSCode == rateCode);
                    if (rate != null) {
                        allowedRateCodes = _.union(rate.AllowedAddOnPackages);
                    }
                    //let something = accountConfiguration.
                }


                for (var ai in availability) {
                    let packageAvailability = availability[ai];

                    let content = configuration.find(item => item.PMSCode == packageAvailability.Code);

                    //lets first check if we have any content - if ther eis no content, we can't show...
                    if (content == null) {
                        continue;
                    }

                    //now check any of our rates support the pacakge...

                    if (!allowedRateCodes.includes(packageAvailability.Code)) {
                        continue;
                    }



                    let packageResult = {
                        availability: packageAvailability,
                        content,
                        quantity: 1
                    };


                    result.push(packageResult);


                }

                return result;
            },
            perItemPackages() {
                if (this.packages.length) {


                    return this.packages.filter(item => item.availability.PriceCalculationMode == 0);
                }
                return [];
            },

            nonPerItemPackages() {
                if (this.packages.length) {


                    return this.packages.filter(item => item.availability.PriceCalculationMode != 0);
                }
                return [];
            },
            availablePackages() {
                if (this.packages.length) {


                    return this.packages.filter(item => item.availability != undefined && item.availability != null);
                }
                return [];
            }


        },
        mounted() {
            var o = this;
            var payload = {
                arrivalDate: moment(this.booking[0].DateRange.StartDate).format('YYYY-MM-DD'),
                numberOfNights: moment(this.booking[0].DateRange.EndDate).diff(moment(this.booking[0].DateRange.StartDate), 'days'),
                guestOccupancies: [{ adults: 1 }]
            };






            stayapi.fetchPackages(payload, (t) => {
                if (t.IsAvailable) {
                    o.localPackages = t.Packages;
                }
                o.isLoading = false;

            });
        }
    }
</script>

<style scoped></style>

<style src="@/modules/stay/css/add-ons.css"></style>

